<div class="overflow-hidden">
  @if (event$(); as event) {
    <app-event-header
      [subTitle]="event.eventType?.name"
      [title]="event.title || ''"
      [image]="event.image"
      [youtubeUrl]="event.videoUrl"
      [intro]="event.description"
      [mobileSubTitleSuffix]="event.startDate | eventDate: event.endDate"
      [eventLabel]="event.label"
    >
      <app-breadcrumbs [backButton]="true" [breadcrumbs]="breadcrumbs()" above></app-breadcrumbs>

      @if (event.cta?.button?.routerLink || event.cta?.text) {
        <div class="card event-header-cta" content>
          <span>{{ event.cta?.text || ('agenda-detail-kaarten-bestellen-prefix' | fromDictionary) }}</span>

          <fstr-link class="d-inline-block ms-auto" cssClasses="button button--primary" [button]="event.cta?.button!"></fstr-link>
        </div>
      }

      <div below>
        <app-event-practical-info [event]="event"></app-event-practical-info>
      </div>
    </app-event-header>

    <section class="container pt-4 pt-md-0">
      <h1 class="sr-only">Over dit agenda-item</h1>

      @if (event.text) {
        <ngx-dynamic-hooks
          class="markdown-content d-block text-max-width-sm mx-auto p-3 p-md-4"
          [options]="{ sanitize: false, updateOnPushOnly: true }"
          [content]="event.text! | resizeHtmlImages | stripEmbed: cookiePreferences$() || undefined"
          fstrDynamicContent
        ></ngx-dynamic-hooks>
      }

      <!-- Other event dates
      @if ((event.eventDates?.length || 0) > 1) {
        <section class="section-outset-y">
          <h3 class="h4">{{ 'event-detail-meer-data' | fromDictionary }}</h3>
          <ul>
            @for (date of event.eventDates; track $index) {
              <li>
                <a
                  [class.text-black]="(date | date: 'dd-MM-yyyy') === (event.startDate | date: 'dd-MM-yyyy')"
                  [routerLink]="['/', 'agenda', event.id, date | date: 'dd-MM-yyyy', event.title | urlRewrite]"
                >
                  {{ date | eventDate: event.endDate }}
                </a>
              </li>
            }
          </ul>
        </section>
      }-->

      <div class="d-md-none mt-3" below>
        <app-event-practical-info [event]="event" [showOnlyImportantInfo]="isShortText()"></app-event-practical-info>
      </div>

      @if (event.cta?.button?.url && event.text.length > 1000) {
        <div class="card mt-auto event-header-cta bg-primary-subtle text-max-width-sm mx-auto" content>
          <span>{{ event.cta?.text || ('agenda-detail-kaarten-bestellen-prefix' | fromDictionary) }}</span>

          <fstr-link class="d-inline-block ms-auto" cssClasses="button button--primary  " [button]="event.cta!.button"></fstr-link>
        </div>
      }
    </section>

    <app-event-metadata class="d-block mt-3" [event]="event"></app-event-metadata>

    @if (relatedEvents$().length) {
      <app-content-block-agenda
        class="section-outset-t d-block"
        [block]="{
          id: 0,
          title: ('agenda-detail-gerelateerd-titel' | fromDictionary),
          blockType: '',
          events: relatedEvents$(),
        }"
        [index]="0"
      ></app-content-block-agenda>
    }
  }
  <!--<pre>{{ event$() | json }}</pre>-->
</div>
